import type { PublicUser } from "../../shared/types";
import { WelcomePage } from "./WelcomePage";
export function AccessPage({onAuthenticated}:{onAuthenticated:(user:PublicUser)=>void}) { return <WelcomePage user={null} onAuthenticated={onAuthenticated}/>; }
